import {connect} from 'react-redux';

import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../../../src/helpers/reselectHelpers';
import {updateSizeAction} from '../../../../../../../src/store/data/localPreferences/localPreferencesActions';
import {getSizes} from '../../../../../../../src/store/data/localPreferences/localPreferencesSelectors';
import {ContactsManagerSidePanelWrapper} from './contactsManagerSidePanelWrapper';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  sizes: getSizes,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  updateSize: updateSizeAction,
}));

export const ContactsManagerSidePanelWrapperContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactsManagerSidePanelWrapper);
